import React, { Component, useState } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

import { useNavigate } from 'react-router-dom'; // React Router's useNavigate hook

import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";
import Home from "../../pages/Home/Home";
import Overview from "../../components/overview/Overview";



const SigninWidget = () => {

  return (
    <div>
      <AuthenticatedTemplate>
        <Overview />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  )
}

export default SigninWidget
